import dayjs from "dayjs";
import config from "../config.json";
const hostname = window.location.hostname;

export const validateStatus = (state) => {
  const status = [200, 201, 202, 203, 204, 204];
  if (status && status.indexOf(state) > -1) {
    return true;
  }
  return false;
};
export const validateArray = (list) => {
  return list && Array.isArray(list) && list.length > 0;
};

export const validateUrlToOpen = (url, institutionParam) => {
  if (url?.startsWith("/")) {
    if (hostname === config.hostname) {
      if (institutionParam?.find((i) => i.code === "mediaRequest")?.value) {
        return (
          institutionParam?.find((i) => i.code === "mediaRequest")?.value + url
        );
      }
      return url;
    } else {
      if (institutionParam?.find((i) => i.code === "mediaRequest2")?.value) {
        return (
          institutionParam?.find((i) => i.code === "mediaRequest2")?.value + url
        );
      }
      return url;
    }
  }

  return url;
};

export function roundDecimals(num) {
  return num && typeof num === "number" ? Math.round(num * 100) / 100 : 0;
}

export function numberWithDecimals(num) {
  return num || num === 0
    ? roundDecimals(num).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : "";
}

export function redondearPersonalizado(num) {
  const parteEntera = Math.floor(num);
  const decimal = num - parteEntera;

  if (decimal >= 0.51) {
    return Math.ceil(num);
  } else {
    return Math.floor(num);
  }
}
export const generateYearsArray = () => {
  const currentYear = dayjs().year();
  const currentMonth = dayjs().month();
  const includeNextYear = currentMonth >= 10;

  const years = [];
  for (let year = currentYear; year >= 2023; year--) {
    years.push({
      label: year.toString(),
      name: year.toString(),
      initial: year === currentYear,
    });
  }

  if (includeNextYear) {
    years.unshift({
      label: (currentYear + 1).toString(),
      name: (currentYear + 1).toString(),
    });
  }

  return years;
};
export const roundUpCustom = (numero) => {
  const decimal = numero - Math.floor(numero);
  return decimal > 0.5 ? Math.ceil(numero) : Math.floor(numero);
};
